/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { LogoTelegramIcon16Light } from './LogoTelegramIcon16Light';
import { LogoTelegramIcon16Regular } from './LogoTelegramIcon16Regular';
import { LogoTelegramIcon16Solid } from './LogoTelegramIcon16Solid';
import { LogoTelegramIcon20Light } from './LogoTelegramIcon20Light';
import { LogoTelegramIcon20Regular } from './LogoTelegramIcon20Regular';
import { LogoTelegramIcon20Solid } from './LogoTelegramIcon20Solid';
import { LogoTelegramIcon24Regular } from './LogoTelegramIcon24Regular';
import { LogoTelegramIcon24Solid } from './LogoTelegramIcon24Solid';
import { LogoTelegramIcon32Regular } from './LogoTelegramIcon32Regular';
import { LogoTelegramIcon64Regular } from './LogoTelegramIcon64Regular';
var sizes = {
    16: {
        light: LogoTelegramIcon16Light,
        regular: LogoTelegramIcon16Regular,
        solid: LogoTelegramIcon16Solid,
    },
    20: {
        light: LogoTelegramIcon20Light,
        regular: LogoTelegramIcon20Regular,
        solid: LogoTelegramIcon20Solid,
    },
    24: {
        regular: LogoTelegramIcon24Regular,
        solid: LogoTelegramIcon24Solid,
    },
    32: {
        regular: LogoTelegramIcon32Regular,
    },
    64: {
        regular: LogoTelegramIcon64Regular,
    },
};
export var LogoTelegramIcon = forwardRef('LogoTelegramIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
